import React, { useEffect, useState } from 'react';
import { CTAButton } from '../ui/CTAButton';
export function HeroSection() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const timeString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <>
      {/* Countdown Timer */}
      <div className="fixed top-0 left-0 w-full z-50 flex justify-center pt-3 px-4 pointer-events-none" data-id="element-187">
        <div className="bg-[#1B4332] text-[#FAF7F2] text-xs md:text-sm px-5 py-2 rounded-full shadow-md font-medium tracking-wide pointer-events-auto border border-[#2D5016]/30" data-id="element-188">
          {timeLeft > 0 ? <p className="flex items-center gap-2" data-id="element-189">
              <span className="text-[#D4A853]" data-id="element-190">⏳</span> OFERTA EXPIRA EN:{' '}
              {timeString} <span className="text-[#D4A853] ml-1" data-id="element-191">🔥</span> CUPOS
              LIMITADOS
            </p> : <p className="flex items-center gap-2" data-id="element-192">
              OFERTA EXPIRADA <span className="text-[#D4A853] ml-1" data-id="element-193">🔥</span>{' '}
              CUPOS LIMITADOS
            </p>}
        </div>
      </div>

      <section className="pt-24 pb-16 px-4 bg-[#FAF7F2] flex flex-col items-center text-center relative overflow-hidden" data-id="element-194">
        <div className="max-w-4xl mx-auto w-full" data-id="element-195">
          <div className="animate-[fadeInUp_0.8s_ease-out_forwards]" data-id="element-196">
            <h1 className="text-5xl md:text-7xl font-bold text-[#1B4332] mb-4 leading-tight tracking-tight" style={{
            fontFamily: "'Playfair Display', Georgia, serif"
          }} data-id="element-197">
              🍗 ADELGAZA CON AIR FRYER
            </h1>

            <h2 className="text-xl md:text-2xl font-medium text-[#2D5016] mb-8 max-w-2xl mx-auto" data-id="element-198">
              El sistema completo para perder peso cocinando con tu freidora de
              aire
            </h2>

            <a href="#compra" className="block cursor-pointer mb-6 transform hover:scale-[1.02] transition-transform duration-500" data-id="element-199">
              <img src="https://cdn.magicpatterns.com/uploads/aAuAWwscCyV3b5kXHSEv9g/ChatGPT_Image_29_abr_2026,_12_00_45.webp" alt="Adelgaza con Air Fryer MegaPack" className="w-full max-w-2xl mx-auto rounded-2xl shadow-lg" fetchPriority="high" decoding="async" width={1024} height={1024} data-id="element-200" />
            </a>

            <p className="text-lg md:text-xl text-[#1B4332] mb-8 font-medium" data-id="element-201">
              Sin pasar hambre. Sin rendirte el jueves. Sin efecto rebote.
            </p>

            <CTAButton href="#compra" text="→ QUIERO MI MEGAPACK AHORA" data-id="element-202" />

            {/* Social Proof Bar */}
            <div className="mt-12 mb-12 overflow-x-auto" data-id="element-203">
              <div className="inline-flex items-center gap-8 bg-[#F5F0E8] px-8 py-4 rounded-2xl border border-[#D4A853]/20 shadow-sm min-w-max" data-id="element-204">
                <span className="text-[#1B4332] font-medium text-sm md:text-base whitespace-nowrap" data-id="element-205">
                  +1.200 personas ya adelgazando
                </span>
                <span className="text-[#1B4332] font-medium text-sm md:text-base whitespace-nowrap" data-id="element-206">
                  6 libros completamente listos
                </span>
                <span className="text-[#1B4332] font-medium text-sm md:text-base whitespace-nowrap" data-id="element-207">
                  4,9/5 ⭐⭐⭐⭐⭐
                </span>
              </div>
            </div>

            {/* Initial Testimonials */}
            <div className="max-w-3xl mx-auto space-y-6 text-left" data-id="element-208">
              <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 shadow-sm" data-id="element-209">
                <div className="flex gap-1 mb-2" data-id="element-210">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#D4A853]" data-id="element-211">
                      ⭐
                    </span>)}
                </div>
                <p className="text-[#1B4332] text-base leading-relaxed mb-2" data-id="element-212">
                  "Llevaba dos años con la Air Fryer cogiendo polvo. Desde que
                  tengo el MegaPack la uso cada día y he perdido 4 kilos sin
                  pasar hambre."
                </p>
                <p className="text-[#2D5016]/70 text-sm font-medium" data-id="element-213">
                  — María G. | Madrid
                </p>
              </div>

              <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 shadow-sm" data-id="element-214">
                <div className="flex gap-1 mb-2" data-id="element-215">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#D4A853]" data-id="element-216">
                      ⭐
                    </span>)}
                </div>
                <p className="text-[#1B4332] text-base leading-relaxed mb-2" data-id="element-217">
                  "Empecé el lunes con el plan semanal y el viernes ya había
                  perdido casi dos kilos. Por fin una dieta que no te hace
                  miserable."
                </p>
                <p className="text-[#2D5016]/70 text-sm font-medium" data-id="element-218">
                  — Laura P. | Barcelona
                </p>
              </div>

              <div className="bg-[#F5F0E8] p-6 rounded-2xl border border-[#D4A853]/20 shadow-sm" data-id="element-219">
                <div className="flex gap-1 mb-2" data-id="element-220">
                  {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-[#D4A853]" data-id="element-221">
                      ⭐
                    </span>)}
                </div>
                <p className="text-[#1B4332] text-base leading-relaxed mb-2" data-id="element-222">
                  "Tres meses después y sin efecto rebote. Nunca me había pasado
                  esto con ninguna dieta."
                </p>
                <p className="text-[#2D5016]/70 text-sm font-medium" data-id="element-223">
                  — Carmen R. | Valencia
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}